var _path, _path2, _circle, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidPassport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33H22.5C30 33 33 30 33 22.5V13.5C33 6 30 3 22.5 3H13.5C6 3 3 6 3 13.5V22.5C3 30 6 33 13.5 33Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.286 28.2449H15.9229",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0004,
    cy: 15.8681,
    r: 9.33925,
    stroke: "#CACACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4692 15.8681C21.4692 18.5373 21.0319 20.9308 20.3431 22.6384C19.9981 23.4936 19.6 24.1522 19.1834 24.589C18.768 25.0246 18.3682 25.2073 18.0005 25.2073C17.6327 25.2073 17.2329 25.0246 16.8175 24.589C16.4009 24.1522 16.0028 23.4936 15.6578 22.6384C14.9691 20.9308 14.5317 18.5373 14.5317 15.8681C14.5317 13.1988 14.9691 10.8053 15.6578 9.09769C16.0028 8.24255 16.4009 7.58389 16.8175 7.14709C17.2329 6.71151 17.6327 6.52881 18.0005 6.52881C18.3682 6.52881 18.768 6.71151 19.1834 7.14709C19.6 7.58389 19.9981 8.24255 20.3431 9.09769C21.0319 10.8053 21.4692 13.1988 21.4692 15.8681Z",
    stroke: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87817 12.8086H26.3307",
    stroke: "#CACACA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87744 19.1342H26.331",
    stroke: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidPassport);
export default __webpack_public_path__ + "static/media/bfid-passport.064a050127615863ddf650671826ff26.svg";
export { ForwardRef as ReactComponent };